.row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 1;
}

.stars {
  position: relative;
  display: inline-block;
  letter-spacing: 1px;
}

.empty { color: #d6d2cc; }
.full {
  position: absolute;
  inset: 0;
  overflow: hidden;
  white-space: nowrap;
  color: var(--color-ember);
}

.count {
  font-size: 0.85em;
  color: var(--color-ink-soft);
  font-weight: 600;
}

.sm { font-size: 0.85rem; }
.md { font-size: 1rem; }
.lg { font-size: 1.15rem; }
